import { Body2, UserInfo } from '@collaborate-health/uikit'

import { CertificateScopeType } from '../../enums'
import { Certificate } from '../../types'

export interface CertificateOwnerProps {
  certificate: Certificate
}

const CertificateOwner: React.FC<CertificateOwnerProps> = ({ certificate }) => {
  if (
    certificate.ScopeId === CertificateScopeType.ProfileCertificate ||
    certificate.ScopeId === CertificateScopeType.UserCertificate
  ) {
    return <UserInfo avatar={false} item={certificate.Owner} />
  }

  if (certificate.ScopeId === CertificateScopeType.TenantCertificate) {
    return <Body2 noWrap>{`Tenant: ${certificate.TenantName}`}</Body2>
  }

  return null
}

export default CertificateOwner

